import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const DeliveryErrorInternationalStepConfig: StepConfig = {
    type: FormType.DELIVERY_ERROR_INTERNATIONAL
};
